import React from 'react';
import ReactDOM from 'react-dom';
import App from './Widget-regional-senate-aktualne';
import { ThemeProvider } from 'emotion-theming';
import { aktualne } from './themes';


window.renderElections = (id, props = {}) => {
	const root = document.getElementById(id);
	ReactDOM.render(
		<ThemeProvider theme={aktualne}>
			<App {...props} />
		</ThemeProvider>,
		root
	);
};
